<template>
  <v-card class="history" flat>
    <v-expansion-panels
      ref="panel"
      @change="clickPanel"
      v-model="expand"
      accordion
      flat
    >
      <v-expansion-panel>
        <v-expansion-panel-header class="history-time py-0 header-title">
          {{ data.date }}, {{ data.time }} • {{ data.unit }}
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-3">
          <section class="history-data">
            <!-- Dokter -->
            <v-row no-gutters v-if="!data.isGeneral" class="mt-2">
              <v-col cols="6">
                <label>Nama Dokter</label>
                <v-tooltip bottom v-if="isOverflow.doctor">
                  <template v-slot:activator="{ on, attrs }">
                    <p
                      ref="doctorRef"
                      v-bind="attrs"
                      v-on="on"
                      class="name-staff"
                    >
                      {{ data.doctor_by }}
                    </p>
                  </template>
                  <span>{{ data.doctor_by }}</span>
                </v-tooltip>
                <p v-else ref="doctorRef" class="name-staff">
                  {{ data.doctor_by }}
                </p>
              </v-col>

              <v-col cols="6">
                <label>Nama Perawat</label>
                <v-tooltip bottom v-if="isOverflow.nurse">
                  <template v-slot:activator="{ on, attrs }">
                    <p
                      ref="nurseRef"
                      v-bind="attrs"
                      v-on="on"
                      class="name-staff"
                    >
                      {{ data.nurse_by }}
                    </p>
                  </template>
                  <span>{{ data.nurse_by }}</span>
                </v-tooltip>
                <p v-else class="name-staff">{{ data.nurse_by }}</p>
              </v-col>
            </v-row>
            <v-row no-gutters v-else>
              <v-col cols="12">
                <label>Nama Petugas Kesehatan</label>
                <p>{{ data.doctor_by || data.nurse_by || '-' }}</p>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <!-- Subjective -->
            <v-row no-gutters class="d-flex flex-column">
              <h3>SUBJEKTIF</h3>
              <label>Anamnesis Dokter</label>
              <p v-if="!data.is_filled">-</p>
              <div v-else>
                <p
                  v-for="(item, index) in data.assesment.doctorAnamnesis"
                  :key="index"
                >
                  {{ item }}
                </p>
              </div>
              <v-divider></v-divider>

              <label>Anamnesis Perawat</label>
              <p v-if="!data.is_filled">-</p>
              <div v-else>
                <p
                  v-for="(item, index) in data.subjective.anamnesis"
                  :key="index"
                >
                  {{ item }}
                </p>
              </div>

              <v-divider></v-divider>
              <label>Riwayat Alergi</label>
              <div v-if="!data.has_allergy">
                <p>-</p>
              </div>
              <div
                v-if="data.has_allergy && data.subjective.allergy_drug.length"
              >
                <ul>
                  <li class="red-text">
                    <p class="red-text">
                      Alergi Obat :
                      {{ data.subjective.allergy_drug.join(', ') }}
                    </p>
                  </li>
                </ul>
              </div>
              <div
                v-if="data.has_allergy && data.subjective.allergy_food.length"
              >
                <ul>
                  <li class="red-text">
                    <p class="red-text">
                      Alergi Makanan :
                      {{ data.subjective.allergy_food.join(', ') }}
                    </p>
                  </li>
                </ul>
              </div>
              <div
                v-if="data.has_allergy && data.subjective.allergy_air.length"
              >
                <ul>
                  <li class="red-text">
                    <p class="red-text">
                      Alergi Udara :
                      {{ data.subjective.allergy_air.join(', ') }}
                    </p>
                  </li>
                </ul>
              </div>
              <div
                v-if="
                  data.has_allergy && data.subjective.allergy_history.length
                "
              >
                <ul>
                  <li class="red-text">
                    <p class="red-text">
                      Alergi Lainnya :
                      {{ data.subjective.allergy_history.join(', ') }}
                    </p>
                  </li>
                </ul>
              </div>

              <v-divider></v-divider>
              <label>Riwayat Penyakit</label>
              <div v-if="data.subjective.disease_history.length">
                <p
                  v-for="(item, index) in data.subjective.disease_history
                    .length"
                  :key="index"
                >
                  {{ item }}
                </p>
              </div>
              <div v-else>
                <p>-</p>
              </div>

              <v-divider></v-divider>
              <label>Riwayat Pengobatan</label>
              <div
                v-if="
                  data.subjective?.treatment_history &&
                    data.subjective?.treatment_history !== ''
                "
              >
                <p>
                  {{ data.subjective?.treatment_history }}
                </p>
              </div>
              <div v-else>
                <p>-</p>
              </div>
            </v-row>

            <!-- Objective -->
            <v-divider></v-divider>
            <v-row no-gutters class="flex-column objektif-section">
              <h3>OBJEKTIF</h3>
              <div class="vital-label mb-1">Tanda-Tanda Vital</div>
              <div class="vital-row">
                <span class="vital-item">
                  <span class="vital-label">TD:</span>
                  <span>{{
                    data.is_filled
                      ? `${data.objective.sistol}/${data.objective.diastol} mm/Hg`
                      : '-'
                  }}</span>
                </span>
                <span class="vital-item">
                  <span class="vital-label">Suhu:</span>
                  <span>{{
                    data.is_filled ? `${data.objective.temperature}°C` : '-'
                  }}</span>
                </span>
                <span class="vital-item">
                  <span class="vital-label">Nadi:</span>
                  <span>{{
                    data.is_filled
                      ? `${data.objective.heart_rate} x/menit`
                      : '-'
                  }}</span>
                </span>
              </div>
              <div class="vital-row">
                <span class="vital-item">
                  <span class="vital-label">RR:</span>
                  <span>{{
                    data.is_filled
                      ? `${data.objective.respiration_rate} x/menit`
                      : '-'
                  }}</span>
                </span>
                <span class="vital-item">
                  <span class="vital-label">Saturasi:</span>
                  <span>{{
                    data.is_filled && data.objective?.saturation
                      ? `${data.objective?.saturation} %`
                      : '-'
                  }}</span>
                </span>
                <span class="vital-item">
                  <span class="vital-label">TB:</span>
                  <span>{{
                    data.is_filled ? `${data.objective.height} cm` : '-'
                  }}</span>
                </span>
                <span class="vital-item">
                  <span class="vital-label">BB:</span>
                  <span>{{
                    data.is_filled ? `${data.objective.weight} kg` : '-'
                  }}</span>
                </span>
              </div>
              <div class="vital-row">
                <span class="vital-item">
                  <span class="vital-label">Lingkar Perut:</span>
                  <span>{{
                    data.is_filled && data.objective?.belly_circumference
                      ? `${data.objective?.belly_circumference} cm`
                      : '-'
                  }}</span>
                </span>
                <span class="vital-item">
                  <span class="vital-label">Kesadaran:</span>
                  <span>{{
                    data.is_filled ? `${data.objective.awarness}` : '-'
                  }}</span>
                </span>
                <span
                  class="vital-item"
                  v-if="data.is_filled && data.objective.djj"
                >
                  <span class="vital-label">DJJ:</span>
                  <span>{{ `${data.objective.djj} x/menit` }}</span>
                </span>
              </div>
            </v-row>

            <!-- IMT -->
            <v-divider></v-divider>
            <v-row no-gutters class="d-flex flex-column mb-3">
              <div class="history-row">
                <div class="history-col">
                  <label>IMT</label>
                  <div v-if="!data.imt.text">-</div>
                  <div :class="`history-chip-${data.imt?.color}`" v-else>
                    {{ data.imt?.text }}
                  </div>
                </div>
                <div class="history-col">
                  <label>Skrining Gizi</label>
                  <div v-if="!data.nutritionScreening.text">-</div>
                  <div
                    v-else
                    :class="`history-chip-${data.nutritionScreening?.color}`"
                  >
                    {{ data.nutritionScreening?.text }}
                  </div>
                </div>
                <div class="history-col">
                  <label>Risiko Jatuh</label>
                  <div v-if="!data.fallRisk.text">-</div>
                  <div v-else :class="`history-chip-${data.fallRisk?.color}`">
                    {{ data.fallRisk?.text }}
                  </div>
                </div>
              </div>
            </v-row>

            <!-- Penanda Anatomi Tubuh -->
            <v-divider v-if="data.anatomical_markers.length"></v-divider>
            <v-row
              v-if="data.anatomical_markers.length"
              no-gutters
              class="d-flex flex-column"
            >
              <label>Penanda Anatomi Tubuh</label>
              <p
                v-for="(item, index) in data.anatomical_markers"
                :key="index"
                class="anatomy-desc"
              >
                {{ index + 1 }}. {{ item }}
              </p>
              <div class="d-flex flex-row-reverse">
                <v-btn
                  class="text-none btn-anatomy"
                  color="primary"
                  text
                  @click="openDialog"
                  >Lihat Anatomi
                  <v-icon v-bind="attrs" v-on="on" :size="20"
                    >mdi-arrow-top-right</v-icon
                  >
                </v-btn>
              </div>
            </v-row>

            <!-- Asesmen -->
            <v-row no-gutters class="d-flex flex-column">
              <v-divider></v-divider>
              <h3>ASESMEN</h3>
              <div>
                <label>Diagnosa Utama</label>
                <p>{{ data.assesment.main_diagnose || '-' }}</p>
              </div>
              <v-divider> </v-divider>
              <div>
                <label>Diagnosa Sekunder</label>
                <div v-if="data.assesment.other_diagnose.length">
                  <ul>
                    <li
                      v-for="(item, index) in data.assesment.other_diagnose"
                      :key="`list-${index}`"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </div>
                <div v-else>
                  <p>-</p>
                </div>
              </div>
            </v-row>
            <!-- Planning -->
            <v-divider> </v-divider>
            <v-row no-gutters class="d-flex flex-column">
              <h3>PLANNING</h3>
              <label>Rencana Pelayanan / KIE</label>
              <div v-if="data.planning.treatment.length">
                <ul>
                  <li
                    v-for="(item, index) in data.planning.treatment"
                    :key="`list-${index}`"
                  >
                    {{ item }}
                  </li>
                </ul>
              </div>
              <div v-else>
                <p>-</p>
              </div>

              <label>Rencana Terapi</label>
              <div v-if="data.planning.therapy.length">
                <ul>
                  <li
                    v-for="(item, index) in data.planning.therapy"
                    :key="`list-${index}`"
                  >
                    {{ item }}
                  </li>
                </ul>
              </div>
              <div v-else>
                <p>-</p>
              </div>
            </v-row>

            <v-row no-gutters class="d-flex flex-column mb-2">
              <label>Terapi (Obat)</label>
              <div v-if="data.recipe">
                <ul>
                  <li class="drug-title">Non Racik</li>
                  <p v-if="!data.recipe || !data?.recipe?.non_mix.length">-</p>
                  <ul v-else>
                    <li
                      v-for="(item, index) in data?.recipe?.non_mix"
                      :key="index"
                    >
                      {{ item }}
                    </li>
                  </ul>
                  <div v-if="data?.recipe?.mix">
                    <div v-for="(item, index) in data.recipe.mix" :key="index">
                      <li class="drug-title">{{ item.name }}</li>
                      <ul>
                        <li
                          v-for="(mix_item, index_item) in item.items"
                          :key="index_item"
                        >
                          {{ mix_item }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </ul>
              </div>
              <p v-else>-</p>
            </v-row>
          </section>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Riwayat Anatomi -->
    <v-dialog max-width="1700" v-model="dialog">
      <!-- <h1>lalal</h1> -->
      <history-anatomical-mark
        :id_emr="id_emr"
        :header-data="headerData"
        :id-registration="data.id_registration"
        @close="closeDialog"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import HistoryAnatomicalMark from './HistoryAnatomicalMark.vue';

export default {
  name: 'HistoryCard',
  components: {
    HistoryAnatomicalMark,
  },
  props: {
    data: {
      type: Object,
    },
    headerData: {
      type: Object,
      default: null,
    },
    id_emr: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
      expand: 0,
      isOverflow: {
        doctor: false,
        nurse: false,
      },
    };
  },
  mounted() {
    this.checkOverflowStaff();
  },
  methods: {
    clickPanel() {
      if (this.expand === 0) {
        this.$emit('panel-open');
      } else {
        this.$emit('panel-close');
      }
    },
    checkOverflowStaff() {
      this.isOverflow.doctor = this.data.doctor_by.length > 30 ? true : false;
      this.isOverflow.nurse = this.data.nurse_by.length > 30 ? true : false;
    },
    closePanel() {
      this.expand = 1;
    },
    openPanel() {
      this.expand = 0;
    },
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
  },
  // mounted() {
  //   this.expand = this.data.index ? undefined : 0;
  // },
};
</script>

<style lang="scss" scoped>
.header-title {
  border-radius: 10px;
  background-color: #f0f8fe;
  border: 0px;
}
.red-text {
  color: red;
}
@mixin result-chip($fill, $outline) {
  background-color: $fill;
  display: flex;
  align-content: center;
  justify-content: center;
  border-radius: 3px;
  color: $outline !important;
  font-weight: 450;
  padding: 0.3rem 0.5rem;
  width: max-content;
  max-height: 2rem;
  font-size: $font-chip-size !important;
}
$text-color: (
  'label': #9e9e9e,
  'data': #242424,
);
$font-standard-size: 0.85vw;
$font-chip-size: 0.65vw;

.history-data,
.history-data p,
.history-data li,
.history-data ul {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}

.history {
  border-radius: 10px;
  width: 100% !important;
  border: 0.1em solid #c2c2c2;
  color: map-get($text-color, 'data');

  .name-staff {
    display: -webkit-box;
    line-clamp: 1;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    max-width: 100%; /* or set a fixed width if needed */
  }

  .anatomy-desc {
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
  }

  .history-row {
    display: flex;
    gap: 20px; /* Increase this for a bigger gap */ /* Optional: space between columns */
    align-items: flex-start;
  }
  .history-col {
    /* Let content decide width */
    display: flex;
    flex-direction: column;
    min-width: 0; /* Prevent overflow */
  }

  #{&}-title {
    font-size: 0.85vw !important;
  }
  #{&}-time {
    font-size: $font-standard-size !important;
    font-weight: 600;
  }
  #{&}-data {
    align-items: baseline;
    padding: 0.2rem 0.2rem;
    text-align: start;

    h3 {
      margin-top: 0.4vw;
      margin-bottom: 0.1vw;
      font-weight: 500;
    }

    label {
      color: map-get($text-color, 'label');
      font-size: $font-standard-size;
      font-weight: 500;
      letter-spacing: 0.001vw;
      margin-top: 0.5vh;
    }

    p {
      padding: 0;
      margin: 0;
      font-size: $font-standard-size;
      text-align: start;
      margin-top: 0.5vh;
      color: map-get($text-color, 'data');
      margin-bottom: 0.2vw;
    }

    div,
    ul {
      font-size: $font-standard-size;
      text-align: start;
      //   margin-top: 0.3vw;
      //   margin-bottom: 0.7vw;
      color: map-get($text-color, 'data');
    }

    .red-text {
      color: red;
    }

    .objektif-section h3 {
      margin-top: 0.4vw;
      margin-bottom: 0.1vw;
      font-weight: 500;
    }

    .vital-label {
      font-weight: 500;
      color: #757575;
      font-size: $font-standard-size;
    }

    .vital-row {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 0.5vh;
    }

    .vital-item {
      margin-right: 18px;
      display: flex;
      align-items: center;
      font-size: $font-standard-size;
    }

    .vital-item .vital-label {
      font-weight: 400;
      margin-right: 2px;
      color: #757575;
    }

    .drug-title {
      color: #9e9e9e;
    }

    .btn-anatomy {
      font-weight: 600;
      font-size: $font-standard-size;
    }
  }

  #{&}-chip {
    font-size: 0.5vw !important;
  }

  #{&}-chip-green {
    @include result-chip(#e5fff0, #2d965a);
  }
  #{&}-chip-yellow {
    @include result-chip(#fff9e5, #e5a82e);
  }
  #{&}-chip-light-yellow {
    @include result-chip(#ffffff, #d1d600);
  }
  #{&}-chip-red {
    @include result-chip(#fff2f2, #eb4747);
  }
}
</style>
